import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCategoryCardsComponent } from './components/product-category-cards/product-category-cards.component';
import { RouterModule } from '@angular/router';
import { HomeHeroComponent } from './components/home-hero/home-hero.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { PartnershipsComponent } from './components/partnerships/partnerships.component';
import { ServicePortalComponent } from './components/service-portal/service-portal.component';
import { TeaserCardComponent } from './components/teaser-card/teaser-card.component';
import { HomeViewComponent } from './views/home-view/home-view.component';
import { SharedModule } from '../shared/shared.module';
import { DisplayPriceComponent } from 'app/shared/components/display-price/display-price.component';

@NgModule({
    declarations: [
        HomeViewComponent,
        ProductCategoryCardsComponent,
        IntroductionComponent,
        ServicePortalComponent,
        TeaserCardComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        DisplayPriceComponent,
        HomeHeroComponent,
        PartnershipsComponent,
    ],
    exports: [],
})
export class HomeModule {}
